import React from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';

const ListaAlertas = (props) => {
  if (!props.alertas || props.alertas.length === 0) {
    return null;
  }
  const montaAlerta = (alerta, index) => {
    if (alerta.descricao) {
      return (
        <React.Fragment>
          <p><b>{index + 1} - {alerta.descricao}</b></p>
        </React.Fragment>
      );
    }
    return (<p><b>{index + 1} - {alerta.descricao}</b></p>);
  };
  const listaAlertas = props.alertas.map((alerta, index) => (
    montaAlerta(alerta, index)
  ));
  return (
    <DtpAccordionGroup>
      <DtpAccordionPanel
        headingId="alertas"
        panelId="lista-alertas"
        icon="ico-alert"
        title="Alertas"
      >
        {listaAlertas}
      </DtpAccordionPanel>
    </DtpAccordionGroup>
  );
};
ListaAlertas.propTypes = {
  // Conteúdo exibido no corpo do modal
  alertas: PropTypes.arrayOf(PropTypes.shape({
    descricao: PropTypes.string,
  })).isRequired,
};
export default ListaAlertas;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ListaAlertas.jsx